<template>
   <pos-documents :configurl="'/api/shippingnotes/create'" />
</template>
<script>
import PosDocuments from "../pos-document/receipt/Receipt.vue";
export default {
   components: {
      PosDocuments
   },
   computed: {
      createFromSNLink() {
         return "/api/sales/createfromSN/" + this.shippingNoteId
      }
   }
};
</script>